import { api } from "lib/graphql/api"
import { gql } from "@apollo/client"
import { query } from "lib/graphql/query"

export const schemaUpdates = api(async function schemaUpdates() {
    return query(
        gql`
            query schemaUpdates {
                schemaUpdates
            }
        `,
        {},
        { returns: "schemaUpdates" }
    )
})
